<template>
  <div class="page-content">
    <div class="content">
      <h1 class="page-title">{{ $t('static.title') }}</h1>
      <div class="intro-section">
        <img src="../assets/img/pingtaihexin.png" alt="静态收益" class="section-image" />
        <div class="article">
          <p>{{ $t('static.intro') }}</p>
          <div class="table-container">
            <table class="revenue-table">
              <thead>
                <tr>
                  <th>{{ $t('static.table.investment') }}</th>
                  <th>{{ $t('static.table.period') }}</th>
                  <th>{{ $t('static.table.return') }}</th>
                  <th>{{ $t('static.table.settlement') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t('static.table.row1.investment') }}</td>
                  <td>{{ $t('static.table.row1.period') }}</td>
                  <td>{{ $t('static.table.row1.return') }}</td>
                  <td>{{ $t('static.table.row1.settlement') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('static.table.row2.investment') }}</td>
                  <td>{{ $t('static.table.row2.period') }}</td>
                  <td>{{ $t('static.table.row2.return') }}</td>
                  <td>{{ $t('static.table.row2.settlement') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('static.table.row3.investment') }}</td>
                  <td>{{ $t('static.table.row3.period') }}</td>
                  <td>{{ $t('static.table.row3.return') }}</td>
                  <td>{{ $t('static.table.row3.settlement') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('static.table.row4.investment') }}</td>
                  <td>{{ $t('static.table.row4.period') }}</td>
                  <td>{{ $t('static.table.row4.return') }}</td>
                  <td>{{ $t('static.table.row4.settlement') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="table-note">{{ $t('static.note') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Static',
  mounted() {
    // 监听语言切换事件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate()
    })
  },
  beforeDestroy() {
    this.$root.$off('language-changed')
  }
};
</script>

<style scoped>
.page-content {
  min-height: calc(100vh - 160px);
  width: 100%;
  padding: 0;
  background: var(--bg-primary);
}

.content {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 30px 15px;
  background: var(--bg-primary);
}

.page-title {
  font-size: 42px;
  line-height: 56px;
  font-weight: 700;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 20px;
  border-bottom: 3px solid var(--accent-primary);
}

.intro-section {
  margin-top: 30px;
}

.section-image {
  width: 100%;
  max-width: 100%;
  display: block;
  margin: 0 auto 40px;
}

.article {
  font-size: 18px;
  line-height: 36px;
  color: var(--text-secondary);
  text-align: justify;
  padding: 0 10px 30px;
  width: 100%;
}

.article p {
  margin-bottom: 20px;
}

.table-container {
  overflow-x: auto;
  margin: 40px 0;
}

.revenue-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--bg-card);
  box-shadow: var(--shadow-md);
  border-radius: 8px;
  overflow: hidden;
}

.revenue-table thead {
  background: linear-gradient(135deg, var(--accent-primary) 0%, var(--accent-secondary) 100%);
  color: var(--text-primary);
}

.revenue-table th,
.revenue-table td {
  padding: 18px 25px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
  color: var(--text-secondary);
}

.revenue-table th {
  font-weight: 700;
  font-size: 18px;
  color: var(--text-primary);
}

.revenue-table tbody tr:hover {
  background: var(--bg-card-hover);
}

.revenue-table tbody tr:last-child td {
  border-bottom: none;
}

.table-note {
  margin-top: 20px;
  font-size: 16px;
  color: var(--text-tertiary);
  text-align: center;
  font-weight: 600;
}

@media (max-width: 768px) {
  .content {
    width: 100%;
    padding: 20px 15px;
  }

  .page-title {
    font-size: 28px;
    line-height: 36px;
  }

  .article {
    font-size: 16px;
    line-height: 28px;
    padding: 0 10px 20px;
  }

  .revenue-table {
    font-size: 14px;
  }

  .revenue-table th,
  .revenue-table td {
    padding: 12px 10px;
  }
}
</style>
